import { render, staticRenderFns } from "./CreateBoardMemberPage.vue?vue&type=template&id=1bef3ce0&scoped=true&"
import script from "./CreateBoardMemberPage.vue?vue&type=script&lang=js&"
export * from "./CreateBoardMemberPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef3ce0",
  null
  
)

export default component.exports